import React, { useEffect, useState, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import {
  CButton,
  CCard,
  CCardBody,
  CCol,
  CContainer,
  CForm,
  CInputGroup,
  CRow,
  CSpinner,
} from '@coreui/react-pro'
import Notifications from 'src/components/notifications/NotificationsToaster'

import { AuthContext } from 'src/contexts/authContext'
import { useValidatedPassword } from 'src/hooks/useAuthHooks'
import { PasswordWithValidation } from 'src/components/auth/authComponents'
import Honeypot from 'src/components/hidden/Honeypot'

const NewPassword = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const authContext = useContext(AuthContext)

  const [isSpinnerVisible, setIsSpinnerVisible] = useState(false)

  const { password, setPassword, passwordIsValid } = useValidatedPassword('')
  const {
    password: passwordAgain,
    setPassword: setPasswordAgain,
    passwordIsValid: passwordAgainIsValid,
  } = useValidatedPassword('')
  const [fetchError, setFetchError] = useState('')
  const isValid = !passwordIsValid || !passwordAgainIsValid || password !== passwordAgain

  const resetPassword = async () => {
    setIsSpinnerVisible(true)
    try {
      await authContext.confirmPassword(
        localStorage.getItem('codeRequestedBy'),
        localStorage.getItem('confirmationCode'),
        password,
      )
      await authContext.signInWithEmail(localStorage.getItem('codeRequestedBy'), password)
      navigate('/')
      localStorage.removeItem('codeRequestedBy')
      localStorage.removeItem('codeExpiresAt')
      localStorage.removeItem('confirmationCode')
    } catch (err) {
      resetForm()
      if (err instanceof Error) {
        setFetchError(err.message)
      }
    } finally {
      setIsSpinnerVisible(false)
    }
  }

  const resetForm = () => {
    document.getElementById('auth-new-password-form').reset()
  }

  // onLoad, check if user has stored with an "active" code
  // if not, go away
  useEffect(() => {
    if (
      !localStorage.getItem('codeRequestedBy') ||
      !localStorage.getItem('codeExpiresAt') ||
      !localStorage.getItem('confirmationCode')
    ) {
      localStorage.removeItem('codeRequestedBy')
      localStorage.removeItem('codeExpiresAt')
      localStorage.removeItem('confirmationCode')
    }
  }, [])

  //required to clear error message from state to avoid rerendering
  useEffect(() => {
    setTimeout(() => {
      setFetchError('')
    }, 3000)
  }, [fetchError])

  return (
    <div className='bg-body-tertiary min-vh-100 d-flex flex-row align-items-center'>
      {fetchError ? <Notifications type='error' message={fetchError} /> : null}
      {/* Honey */}
      <Honeypot />
      {/* Honey */}
      <CContainer>
        <CRow className='justify-content-center'>
          <CCol md={5}>
            <CCard className='p-4'>
              <CCardBody>
                <CForm id='auth-new-password-form'>
                  <h1>{t('NewPassword.pageTitle')}</h1>
                  <CInputGroup className='mb-3 d-block'>
                    <PasswordWithValidation
                      password={password}
                      setPassword={setPassword}
                      passwordAgain={passwordAgain}
                      setPasswordAgain={setPasswordAgain}
                    />
                  </CInputGroup>
                  <CButton
                    disabled={isValid}
                    color='primary'
                    onClick={resetPassword}
                    className='px-4'
                    tabIndex={-1}
                  >
                    {isSpinnerVisible ? (
                      <CSpinner color='light' variant='grow' size='sm' />
                    ) : (
                      t('NewPassword.button')
                    )}
                  </CButton>
                </CForm>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  )
}

export default NewPassword
